import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import { CORPORATE_TYPE, FINANCIAL_TYPE } from '../../../common/constant'
import {
  selectFinancials,
  selectIsLoadingSomeData,
} from '../../../common/store/slice'
import {
  changeFinancialTab,
  selectCurrentFinancialTab,
} from '../../store/slice'
import { GroupIndicators } from './GroupIndicators'
import classes from './index.module.scss'

export const Financials = () => {
  const dispatch = useDispatch()

  const currentTab = useSelector(selectCurrentFinancialTab)

  const financials = useSelector(selectFinancials)
  const isLoadingSomeData = useSelector(selectIsLoadingSomeData)

  const changeTab = (key) => {
    dispatch(changeFinancialTab(key))
  }

  const renderIndicators = () => {
    return Object.values(FINANCIAL_TYPE).map((type) => (
      <GroupIndicators
        key={`${currentTab}-${type}`}
        financialType={type}
        indicators={financials[currentTab][type]}
      />
    ))
  }

  return (
    <Element className={classes.financial}>
      <Element className={classes.financialType}>
        {Object.keys(CORPORATE_TYPE).map((key) => (
          <Element
            key={key}
            style={{
              color: key === currentTab ? '#FFFFFF' : '',
              backgroundColor: key === currentTab ? '#2C73E8' : '#FFFFFF',
            }}
            onClick={() => changeTab(key)}
          >
            <Translate value={`screening.${key}`} />
          </Element>
        ))}
      </Element>

      <Element className={classes.financialTree}>
        <ScrollComponent>
          <Element>
            {isLoadingSomeData ? <Loading /> : renderIndicators()}
          </Element>
        </ScrollComponent>
      </Element>
    </Element>
  )
}
